


import React, { useState, useRef } from 'react';

import styles from './settings.module.css';
import { axiosInstance } from '../../../lib/axiosInstance';
import { useGlobalState } from '../../global_state_components/GlobalStateProvider';
import { useAuth } from '../../global_state_components/AuthProvider';
import { useNavigate } from 'react-router-dom';


function Settings(){
    const {contact, setContact} = useGlobalState();
    const {isAuthenticated, setIsAuthenticated} = useAuth();
    const navigate = useNavigate();   
  


  return(
    <div className={styles.main_div}>
      dffd

    </div>

  )

}

export default Settings;